import { Modal, Button } from "react-bootstrap";

const DetailModal = ({
  show,
  onClose,
  data,
  fields,
  onEdit,
  updateBtnText = "Update",
  title,
}) => {
  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {data && (
          <div className="row">
            {fields?.map((field, index) => {
              let value = data[field.key];

              if (field.type === "image") {
                value = value || "/no-avatar.png";
              } else if (field.key.toLowerCase() === "permissions") {
                value = Array.isArray(value)
                  ? value.map((p) => p.label || p).join(", ")
                  : "No Data";
              } else {
                value = value ?? "—";
              }

              return (
                <div className="col-md-6" key={index}>
                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      {field.label}
                    </label>
                    {field.type === "image" ? (
                      <img
                        src={value}
                        alt={field.label}
                        width="50"
                        height="50"
                        className="rounded-circle"
                      />
                    ) : field.isHtml ? (
                      <div
                        className="border rounded p-2"
                        dangerouslySetInnerHTML={{
                          __html: value,
                        }}
                      />
                    ) : (
                      <p className="mb-0">{value}</p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>

        {onEdit && (
          <Button variant="primary" onClick={() => onEdit(data)}>
            {updateBtnText}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default DetailModal;
